import API from "./api";
import API_ROUTES from "./apiRoutes";

/**
 * Submit a request to delete an entity when the user lacks direct delete permissions.
 *
 * @param {Object} params
 * @param {string} params.entity_type - e.g. "User", "Society", "Service", "Amenity", "Tower"
 * @param {string|number} params.entity_id - Identifier of the entity
 * @param {string} params.entity_name - Display name of the entity to verify
 * @param {string} params.reason - Explanation / justification for the deletion
 */
export const requestEntityDeletion = async ({
  entity_type,
  entity_id,
  entity_name,
  reason,
}) => {
  const payload = {
    entity_type: String(entity_type || "Entity").trim(),
    entity_id: entity_id != null ? String(entity_id) : "",
    entity_name: String(entity_name || "").trim(),
    reason: String(reason || "").trim(),
  };

  const res = await API.post(API_ROUTES.deletionRequests, payload);
  return res.data;
};
